import { RemoteFile } from '@models/next/FileType';
import { z } from 'zod';

export const StatusData = z.object({
  name: z.string(),
  time: z.string().nullish(),
  message: z.string().nullish(),
  attached_file: RemoteFile.nullish(),
  reference_id: z.string().nullish(),
});

export type StatusData = z.TypeOf<typeof StatusData>;
